// config 로딩
const env = process.env.NODE_ENV;
const production = env === 'production';
// const publicPath = process.env.NODE_ENV === 'production' ? '/' : '/';
// sonarcube 대응 기존엔 윗라인의 process.env.NODE_ENV 값에 따른 분기문이었음. 향후 모드에 따른 변경 필요시 참고
const publicPath = '/';
const currentTheme = process.env.THEME;

export default {
  popupUrl: `popup.html`,
  // popupUrl: 'popup_' + currentTheme + '.html',
  popupTheme1Url: `popup_theme1.html`,
  popupTheme2Url: `popup_theme2.html`,
  popupTheme3Url: `popup_theme3.html`,
  popupTheme4Url: `popup_theme4.html`,
  publicPath,

  // 데이서 서비스 호출 URL
  dataService: {
    // baseURL: production ? '/' : 'http://localhost:8080',
    baseURL: '/',
    // baseURL: 'http://localhost:8080',
  },
};
